<script lang="ts">
    import { SortableList } from "@jhubbardsf/svelte-sortablejs";
    import { librarySounds, libraryScenes } from "../store";
    import {
        SCENE_FROM_DRAWER_PREFIX,
        SOUND_FROM_DRAWER_PREFIX,
    } from "../global";
    import LibraryScene from "./LibraryScene.svelte";
    import { flip } from "svelte/animate";
    import { fade } from "svelte/transition";
    import { sortableForceFallbackForFirefox } from "../genericHandlers";
    import LibrarySound from "./LibrarySound.svelte";

    export let scenesToShow;
    export let soundsToShow;
    export let showingScenes;
    export let handleOnChooseScene;
    export let handleOnUnchooseScene;
    export let handleOnChooseSound;
    export let handleOnUnchooseSound;
    export let handleSoundPlay;
    export let handleSoundStop;
    export let handleSoundChanged;
</script>

{#if !$librarySounds || !$libraryScenes}
    <div class="center-contents-vh">
        <div>Loading library...</div>
        <progress class="upload-progress" />
    </div>
{:else if showingScenes}
    <SortableList
        class="search-results"
        group={{ name: "scenes", put: false, pull: "clone" }}
        dragClass="scene-container"
        ghostClass="scene-container"
        sort={false}
        onChoose={handleOnChooseScene}
        onEnd={handleOnUnchooseScene}
        forceFallback={sortableForceFallbackForFirefox()}
        handle=".library-scene"
    >
        {#each scenesToShow as scene, idx (scene.Id)}
            <div
                class="library-scene"
                id="{SCENE_FROM_DRAWER_PREFIX}{scene.Id}"
                animate:flip={{ duration: 150 }}
            >
                <LibraryScene publicScene={scene} />
            </div>
        {/each}
    </SortableList>
{:else}
    <SortableList
        class="search-results"
        group={{ name: "sounds-on-lanes", put: false, pull: "clone" }}
        sort={false}
        ghostClass="sound-ghost"
        chosenClass="sound-ghost"
        onChoose={handleOnChooseSound}
        onEnd={handleOnUnchooseSound}
        forceFallback={sortableForceFallbackForFirefox()}
    >
        {#each soundsToShow as sound, soundIdx (sound.Id)}
            <div
                class="sound-container"
                id="{SOUND_FROM_DRAWER_PREFIX}{soundIdx}"
            >
                <LibrarySound
                    publicSound={sound}
                    playFn={handleSoundPlay}
                    stopFn={handleSoundStop}
                    soundUpdatedCallback={(newSound) =>
                        handleSoundChanged(soundIdx, newSound)}
                />
            </div>
        {/each}
    </SortableList>
{/if}
